:host {
  display: inline-block;
}
.logo {
  width: 100%;
  height: 30px;
}
